// Session key for a language the visitor picked with the EN/ES toggle.
// It lives in sessionStorage so a new visit falls back to the browser language.
export const LANGUAGE_CHOICE_KEY = 'site-language-choice';

// Returns the path of the same page in `lang`. Project and book detail pages
// use a translated base path in Spanish
// (/projects/:slug <-> /es-mx/proyectos/:slug, /books/:slug <-> /es-mx/libros/:slug)
export function localizePath(currentPath, lang) {
  let path = currentPath.replace(/^\/(es-mx|en-us)(?=\/|$)/, '') || '/';

  path = lang === 'en-us'
    ? path.replace(/^\/proyectos\/(?=.)/, '/projects/').replace(/^\/libros\/(?=.)/, '/books/')
    : path.replace(/^\/projects\/(?=.)/, '/proyectos/').replace(/^\/books\/(?=.)/, '/libros/');

  return lang === 'en-us' ? path : `/${lang}${path}`;
}
